<template>
    <div>
        <div style="height: 56px;">
            <img style="width: 100%;height: inherit;" src="../../../../../static/img/yushelan.png" alt="">
        </div>

        <div class="newNav">
            <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @select="handleSelect"
                     :collapse="true">
                <el-submenu index="1"  >
                    <template slot="title">
                        <div class="content-title" v-if="wuBoolean">
                            无人机
                        </div>
                        <div class="content-title" v-else>
                            无人机:{{this.wuArr[this.wuIndex].name}}
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-for="( li , index ) in this.wuArr" :key="index" :index="'1-' +  (index*1+1)">
                            {{li.name}}
                        </el-menu-item>
                    </el-menu-item-group>

                </el-submenu>
                <el-submenu index="2">
                    <template slot="title">
                        <div class="content-title" v-if="chuanBoolean">
                            传感器
                        </div>
                        <div class="content-title" v-else>
                            传感器:{{this.chuanArr[this.chuanIndex].name}}
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-for="( li , index ) in this.chuanArr" :key="index" :index="'2-' +  (index*1+1)">
                            {{li.name}}
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="3">
                    <template slot="title">
                        <div class="content-title" v-if="qiBoolean">
                            起飞地点
                        </div>
                        <div class="content-title" v-else>
                            起飞地点:{{this.qifs[this.qiIndex].label}}
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-for="(li , index ) in this.qifs" :key="index" :index="li.value">{{li.label}}
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4">
                    <template slot="title">
                        <div class="content-title" v-if="diBoolean">
                            地面控制点
                        </div>
                        <div class="content-title" v-else>
                            地面控制点:{{this.dimian [this.diIndex].label}}
                        </div>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-for="(li , index ) in this.dimian" :key="index" :index="li.value">{{li.label}}
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <div class="addElement" @click="submitForm(0)"  style="color: white">
                    航线规划
                </div>
                <div class="addElement"  style="cursor: not-allowed" >
                    飞行结果查询与导出
                </div>
                <div class="addElement"  style="cursor: not-allowed">
                    三维建模
                </div>
            </el-menu>

        </div>
        <div class="dialog">
            <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="ifShowIframe"
                       width="80%"
                       height="70vh"
                       top="10vh">model3D
                <!--<iframe style="width: 100%;height: 70vh" v-if="src.indexOf('jpg') == -1 && ifShowIframe == true"-->
                        <!--:src="src" class="mdk-main-iframe"-->
                        <!--frameborder="0" scrolling="no" seamless allowvr allowfullscreen-->
                        <!--mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel=""></iframe>-->
                <model-viewer v-if="src.indexOf('jpg') == -1 && ifShowIframe == true"
                              @loaded="handleLoaded()" :folder="model3Dx()"></model-viewer>
                <div v-if="src.indexOf('jpg') != -1 && ifShowIframe == true">
                    <div>
                        {{remark}}
                    </div>
                    <img :src="src" alt="">
                </div>
                <div v-if="src.indexOf('jpg') == -1 && ifShowIframe == true"
                     style="margin: 0 !important;left: 30px;width: 200px;position: absolute;font-weight: 700;font-size: 18px;">
                    {{remark}}
                </div>
                <div v-if="src.indexOf('jpg') == -1 && ifShowIframe == true"
                     style="position: absolute;width: 200px;top: 500px;right: 50px;font-weight: 700;font-size: 18px;">
                    按住左键可观看3d模型<br>
                    按住右键可拖动<br>
                    可通过滚轮放大/缩小
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import ModelViewer from '../../../../components/3D/ModelViewer.vue'
    export default {
        components:{
            ModelViewer
        },
        props: ['rule', 'model', 'indexArr'],
        name: "index",
        data() {
            return {
                model3D:'',
                feixingqi: '',
                optionIds:[],
                ruleBooleans:false,
                src: 'undefined',
                ifShowIframe: false,
                remark: '',
                wuIndex: '',
                chuanIndex: '',
                qiIndex: '',
                diIndex: '',
                wuBoolean: true,
                chuanBoolean: true,
                qiBoolean: true,
                diBoolean: true,
                isCollapse: true,
                list: '',
                wuArr: [],
                chuanArr: [],
                qifs: [{
                    value: '3-1',
                    label: '起飞地点 A',
                }, {
                    value: '3-2',
                    label: '起飞地点 B',
                }, {
                    value: '3-3',
                    label: '起飞地点 C',
                }, {
                    value: '3-4',
                    label: '起飞地点 D',
                }, {
                    value: '3-5',
                    label: '起飞地点 E',
                },],
                dimian: [
                    {
                        value: '4-1',
                        label: '第一套',
                    },
                    {
                        value: '4-2',
                        label: '第二套',
                    },
                ],
            }
        },
        methods: {
            handleLoaded(){
                scene.moSpecial.cameraSettings({ left: 120, right:120, up: 80, down: 80, in: 0, out:0});
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);

            },
            model3Dx(){
                return  this.model3D
            },
            handleSelect(index) {

                let afterIndex = (index.split('-')[1]) - 1 //子
                let beforeIndex = index.split('-')[0]  //主
                if (beforeIndex == 1) {
                    console.log(this.wuArr[afterIndex])
                    window.open('#/webglTest?model3D='+this.wuArr[afterIndex].dir_name);
                    this.model3D= this.wuArr[afterIndex].dir_name
                    this.src = this.wuArr[afterIndex].dir_name
                    this.ifShowIframe = false
                    this.remark = this.wuArr[afterIndex].remark
                    this.wuIndex = afterIndex
                    this.wuBoolean = false
                } else if (beforeIndex == 2) {
                    this.model3D= this.chuanArr[afterIndex].dir_name
                    this.src = this.chuanArr[afterIndex].img_url
                    this.ifShowIframe = true
                    if (this.model3D){
                        this.ifShowIframe = false
                        window.open('#/webglTest?model3D='+this.chuanArr[afterIndex].dir_name);
                    }

                    this.remark = this.chuanArr[afterIndex].remark
                    this.chuanIndex = afterIndex
                    this.chuanBoolean = false
                } else if (beforeIndex == 3) {
                    this.qiIndex = afterIndex
                    this.qiBoolean = false
                    if (index === '3-1') {

                        this.$emit('qifei', 'qifeiA')

                    } else if (index === '3-2') {

                        this.$emit('qifei', 'qifeiB')

                    } else if (index === '3-3') {

                        console.log(333);
                        this.$emit('qifei', 'qifeiC')

                    } else if (index === '3-4') {

                        this.$emit('qifei', 'qifeiD')
                        this.ruleForm.qi = '起飞地点D'
                    } else if (index === '3-5') {

                        this.$emit('qifei', 'qifeiE')

                    }
                } else if (beforeIndex == 4) {
                    this.diIndex = afterIndex
                    this.diBoolean = false
                    if (index === '4-1') {

                        this.$emit('kongzhi', 1)
                        this.$message('第一组控制点——最优（均匀分布在整个测区，边缘和中间都有点）')
                    } else if (index === '4-2') {

                        this.$emit('kongzhi', 2)
                        this.$message('第二组控制点——较差（未均匀分布，多数点集中在中部，边缘地区会产生畸变）')


                    }
                }
            },
            jumpArr(arr) {
                // 判断是否 数组长度。如果有值 push
                if (this.optionIds.length > 0) {
                    for (let i in arr) {
                        this.optionIds.push(arr[i])
                    }
                } else {
                    //无值情况
                    this.optionIds = arr
                }
            },
            pushArr() {
                if (this.wuArr[this.wuIndex].name == '大疆M100') {
                    let arr = [1, 3, 5, 6, 7, 8, 22]
                    this.feixingqi = 1
                    this.jumpArr(arr)
                } else {
                    this.feixingqi = 2
                    let arr = [2]
                    this.jumpArr(arr)
                }
                this.pushArr2()
            },
            pushArr2() {
                if (this.qifs[this.qiIndex].label == '起飞地点E') {
                    let arr = [4, 9, 10, 11]
                    this.jumpArr(arr)
                } else {
                    let arr = [9, 10, 11]
                    this.jumpArr(arr)
                }
                this.pushArr3()
            },
            pushArr3() {
                if (this.dimian[this.diIndex].label == '第一套') {
                    let arr = [18, 19]
                    this.jumpArr(arr)
                } else {
                    let arr = [19]
                    this.jumpArr(arr)
                }
            },
            //type 2 无人机  3传感器
            getData() {
                let params = {type: ''}
                this.$axios.get(this.URL.uModel.selectUModelList, {params}).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                        for (let i in this.list) {
                            if (this.list[i].type == 2) {
                                this.wuArr.push(this.list[i])
                            } else if (this.list[i].type == 3) {
                                this.chuanArr.push(this.list[i])
                            }
                        }
                    }
                })
            },
            submitForm(index){
                if (index === 0){
                    if (!this.wuBoolean && !this.chuanBoolean && !this.qiBoolean && !this.diBoolean) {
                        this.$confirm('请确认您的选择！您将带着“飞机+传感器”到达' + this.qifs[this.qiIndex].label + '！点击确定后，将无法更改', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.pushArr()
                            let a = JSON.stringify(this.optionIds).replace('[', '')
                            let data = {
                                optionIds: a.replace(']', ''),
                                taskId: sessionStorage.AltizureId
                            }
                            this.$axios.post(this.URL.uUserTask.select, data).then(res => {

                                if (res.status === 200) {
                                    this.optionIds = [];
                                    //跳转路由布尔值
                                    console.log(111111111);
                                    this.ruleBooleans = true;
                                    this.$router.push({
                                        path: '/tizure',
                                        query: {
                                            wurenjiName:this.wuArr[this.wuIndex].name,
                                            chuangName:this.chuanArr[this.chuanIndex].name,
                                            dirName:this.dimian[this.diIndex].label,
                                            qifei: this.qifs[this.qiIndex].label,
                                            tianqi: this.model,
                                            indexArr: this.indexArr,
                                            feixingqi: this.feixingqi,
                                        }
                                    })
                                }
                            })
                                .catch(err => {

                                })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        });


                    } else {

                        this.ruleBooleans = false
                        this.$message.error('请选择正确无人机配置');
                        return false;
                    }
                }
                else if (index === 1){
                    this.goMain('/flight')
                }else{
                    this.goMain('/modeling')

                }
            }
        },
        mounted() {
            this.getData()
        },
    }
</script>

<style lang="less" scoped>
    .el-menu--popup {
        margin-right: 0 !important;
        padding: 0 !important;
    }

    /deep/ .el-menu-item-group__title {
        padding: 0 !important;
    }

    /deep/ .el-menu-item:hover {
        background: #66a3ba !important;
    }

    /deep/ .el-menu--popup-right-start {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    /deep/ .el-menu-item {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: white;
        background: #1e354c;
    }

    .newNav {
        //nav 盒子大小
        .el-menu--collapse {
            width: 100%;
        }
        //
        .el-submenu:first-child {
            border: 2px solid #66a3ba;
            border-image: -webkit-linear-gradient(#66a3ba, #83ccde) 30 30;
            border-image: -moz-linear-gradient(#66a3ba, #83ccde) 30 30;
        }
        .el-submenu {
            border-bottom: 2px solid #66a3ba;
            border-left: 2px solid #66a3ba;
            border-right: 2px solid #66a3ba;

        }

        .el-submenu__title {
            padding: 0 !important;

        }
        /deep/ .el-submenu__title:hover {
            background: #1e354c;
        }
        .el-menu--collapse .el-submenu {
            color: white !important;
            background: #1e354c;
        }

        /deep/ .el-menu-item-group__title {
            padding: 0 !important;
        }

        .content-title {
            color: white;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
        }

        .addElement {
            color: #b7b7b77d;
            height: 56px;
            border-bottom: 2px solid #66a3ba;
            border-left: 2px solid #66a3ba;
            border-right: 2px solid #66a3ba;
            text-align: center;
            line-height: 56px;
            background: #1e354c;
            font-weight: 700;
            font-size: 14px;
            cursor: pointer
        }

        //子级导航背景色

    }

    .dialog {
        /deep/ .el-dialog__body {
            display: flex;
            div {
                margin: 0 auto;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/main/assessment/newNav/index.vue